// Tema escuro do aluno desde o primeiro quadro (antes dos guardas/splash), sem script inline (CSP).
// O painel remove o atributo ao montar (painel/comum/tema.ts). No app nativo não há painel (/painel* cai na tela
// escura "O painel da equipe abre no navegador"): escuro sempre.
if (
  typeof document !== "undefined" &&
  (__ALVO__ === "nativo" || !window.location.pathname.startsWith("/painel"))
) {
  document.documentElement.dataset.tema = "escuro";
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) meta.content = "#0C0D0F";
}
export {};
